export const SORT_BY_OPTIONS = [
  { value: "total_balance", label: "Total Staked ETH" },
  { value: "member_count", label: "Followers" },
  { value: "bonus_sharing", label: "Bonus (% of Yield)" },
  { value: "created_at", label: "Created Time" },
];
export const SORT_IN_OPTIONS = ["desc", "asc"];
